<template>
<nav>  
<v-toolbar height="100" color="white" flat app class="style_menu">
      <v-toolbar-title >
       <a class="hidden-sm-and-down" href="https://lalabumapp.com/"><img src="Lalabum-logohorizontal20080.png" alt=""></a>
       <a class="hidden-md-and-up" href="https://lalabumapp.com/"><img src="Lalabum-logohorizontal20080.png" width="180px" alt=""></a> 
    </v-toolbar-title>
      <v-spacer></v-spacer>
      <!--<v-toolbar-items class="hidden-sm-and-down">-->
          <div  class="hidden-sm-and-down">
        <!-- <router-link class="menu" to="/">
        <v-btn class="btns_menu" color="#558BC3" flat value="Nosotros">
          <span>{{opc1}}</span>
        </v-btn> 661E5E
    </router-link>-->

      
        <a class="menu" href="https://lalabumapp.com/dashboard_maestros" target="_blank">
        <v-btn class="btns_menu" color="#661E5E" flat value="Escuelas">
          <span>{{opc1}}</span>
        </v-btn>
      </a>
      <a class="menu" href="https://lalabumapp.com/escuelas">
        <v-btn class="btns_menu" color="#558BC3" flat value="Escuelas">
          <span>{{opc2}}</span>
        </v-btn>
      </a>
      <a class="menu" href="https://www.lalabumapp.com/padres/?sincache">
        <v-btn class="btns_menu" color="#B53980" flat value="Padres">
          <span>{{opc3}}</span>
        </v-btn>
      </a>
      <a class="menu" href="https://lalabumapp.com/blog/">
        <v-btn class="btns_menu" color="#66A66E" flat value="Blog">
          <span>{{opc4}}</span>
        </v-btn>
      </a>
      <!--<router-link class="menu" to="/Contacto">-->
      <a style="text-decoration:none;" href="#">
        <v-btn class="btns_menu" color="#D35F3B" flat value="Contacto">
          <span>{{opc5}}</span>
        </v-btn>
      <!--</router-link>-->
      </a>
    </div>    

    <v-menu offset-y="">
        <v-btn class="btns_menu" align-center large flat slot="activator" color="grey">
            <img :src="lang_img" height="50" alt="">
        </v-btn>
        <v-list>
          <v-list-tile align-center v-for="item in languages" :key="item.language" router>
            <img align-center @click="change_language(item.language)" v-bind:src="item.image" height="50" alt="">
          </v-list-tile>          
        </v-list>
    </v-menu>

    <v-menu class="hidden-md-and-up">
      <v-toolbar-side-icon flat color="primary" slot="activator" ></v-toolbar-side-icon>   
        
        <v-navigation-drawer app v-model="drawer" temporary absolute class="hidden-md-and-up">
        </v-navigation-drawer>
            <v-list xs12>
              <v-list-tile>
                <v-list-tile-content>
                  <a class="menu" href="https://lalabumapp.com/dashboard_maestros">
                  <v-list-tile-title>{{opc1}}</v-list-tile-title>
                  </a>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>
                  <a class="menu" href="https://lalabumapp.com/escuelas">
                  <v-list-tile-title>{{opc2}}</v-list-tile-title>
                  </a>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>
                  <a href="https://www.lalabumapp.com/padres/?sincache" style="text-decoration:none">
                  <v-list-tile-title>{{opc3}}</v-list-tile-title>
                  </a>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>
                  <a href="https://lalabumapp.com/blog/" style="text-decoration:none">
                  <v-list-tile-title>{{opc4}}</v-list-tile-title>
                  </a>
                </v-list-tile-content>
              </v-list-tile>
              <v-list-tile>
                <v-list-tile-content>
                  <a style="text-decoration:none;" href="#">
                    <v-list-tile-title>{{opc5}}</v-list-tile-title>
                  </a>
                </v-list-tile-content>
              </v-list-tile>              
            </v-list>                   
      </v-menu>
        
    </v-toolbar>       
</nav>
</template>

<script>
    export default {
      data() {   
        
        if(localStorage.getItem('language')===null||localStorage.getItem('language')==""){
        var userLang = navigator.languages[navigator.languages.length-1] || navigator.userLanguage;
        localStorage.setItem('language',userLang);      
      }

        let language=localStorage.getItem('language');
        if (language=='es-XL' || language=='es' || language=='es-ES')
        {
          return{
            languages : [
              {language:'es',image:'esp.png'},
              {language:'en',image:'ingles.png'}
            ],
            opc1:'Maestras',
            opc2:'Programa Escolar',
            opc3:'Padres',
            opc4:'Blog',
            opc5:'Tienda',
            lang_img:'./language.png',
            logo:'/Lalabum-logohorizontal20080.png',
            drawer: false
          }
        } else {
          return{
            languages : [
              {language:'es',image:'esp.png'},
              {language:'en',image:'ingles.png'}
            ],
            opc1:'Us',
            opc2:'School',
            opc3:'Parents',
            opc4:'Blog',
            opc5:'Contact',
            lang_img:'./language.png',
            logo:'/lalabum-logohorizontal20080.png',
            drawer: false
          }
      }
    },
    methods:{
      change_language: function (lang) {        
        
        // alert(localStorage.getItem('language'));
        localStorage.setItem('language', lang)
        location.reload();
      }
    }
    }
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Fredoka+One|Poppins:300,300i,400,400i,500,500i,600,600i,700,700i');

.menu{
    text-decoration:none; 
}
.btns_menu{
   /*padding-left: 0px;
   padding-right: 0px;*/
   margin-right: 0px;
   margin-left: 0px;
}

.style_menu{
  font-family: 'Poppins', sans-serif;
}
</style>